import { Pipe, PipeTransform } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

import { LanguageService } from '../_services/index';

@Pipe({
    name: 'objectImage',
    pure: false,
    standalone: false
})
export class ObjectImagePipe implements PipeTransform {

  constructor(private translateService: TranslateService,
    private languageService: LanguageService) {
  }

  transform(object: any): any {
    const langUrl = this.getStr(object.objectPic);
    if(langUrl){
      return langUrl+'?lastUpdateDate='+object.pictureLastUpdate;
    }
    if(object.pictureUrl){
      return object.pictureUrl+'?lastUpdateDate='+object.pictureLastUpdate;
    }
    return 'https://placehold.it/50x50';
  }

  getStr(objectPic){
    if(objectPic && objectPic[this.languageService.currentLang]){
      if(objectPic[this.languageService.currentLang].thumbFileURL){
        return objectPic[this.languageService.currentLang].thumbFileURL;
      }
      if(objectPic[this.languageService.currentLang].url){
        return objectPic[this.languageService.currentLang].url;
      }
    }
    return null;
  }

}
